import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    timeout: 90000, // LLM generation may take a while
});

export const getTodayLesson = () => api.get("/lessons/today").then((r) => r.data);
export const listLessons = (params = {}) => api.get("/lessons", { params }).then((r) => r.data);
export const getLesson = (id) => api.get(`/lessons/${id}`).then((r) => r.data);
export const generateLesson = (payload = {}) => api.post("/lessons/generate", payload).then((r) => r.data);
export const getThemes = () => api.get("/themes").then((r) => r.data);
export const getStats = () => api.get("/stats").then((r) => r.data);
export const subscribe = (payload) => api.post("/subscribe", payload).then((r) => r.data);
export const lessonAudioUrl = (id) => `${API}/lessons/${id}/audio`;
export const searchLessons = (q) => api.get("/search/lessons", { params: { q } }).then((r) => r.data);
export const getKindnessThisWeek = () => api.get("/kindness/this-week").then((r) => r.data);

// --- Admin (token-gated) ---
const ADMIN_HEADER_KEY = "x-admin-token";
const getAdminToken = () => localStorage.getItem("admin_token") || "";
export const adminFetch = (path, options = {}) => {
    const token = getAdminToken();
    return api({
        url: path,
        method: options.method || "GET",
        data: options.data,
        headers: { [ADMIN_HEADER_KEY]: token, ...(options.headers || {}) },
    }).then((r) => r.data);
};
export const adminDashboard = () => adminFetch("/admin/dashboard");
export const adminSendDaily = () => adminFetch("/admin/send-daily", { method: "POST", data: {} });
export const adminRegenerateToday = () => adminFetch("/admin/regenerate-today", { method: "POST", data: {} });
export const setAdminToken = (t) => localStorage.setItem("admin_token", t);
export const clearAdminToken = () => localStorage.removeItem("admin_token");
export const hasAdminToken = () => !!getAdminToken();
